import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import PageLoader from 'components/common/PageLoader';
import formatNumber from 'helpers/formatNumber';
import Empty from 'components/common/Empty';
import Thumbnail from 'components/common/Thumbnail';
import './index.scss';

const IndividualWalletTable = ({ users, loading, error }) => {
  if (loading) return <PageLoader />;

  if (!loading && error) return null;

  if (!loading && !error && users.length === 0) {
    return <Empty message="No users found" />;
  }

  return (
    <div className="individual-wallet-table">
      <Table basic="very" size="large">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell className="individual-wallet-table__header individual-wallet-table__header--name">
              User
            </Table.HeaderCell>
            <Table.HeaderCell className="individual-wallet-table__header">
              Wallet Balance
            </Table.HeaderCell>
            <Table.HeaderCell className="individual-wallet-table__header">
              Total Saving Balance
            </Table.HeaderCell>
            <Table.HeaderCell className="individual-wallet-table__header">
              Social Fund Balance
            </Table.HeaderCell>
            <Table.HeaderCell className="individual-wallet-table__header">
              Status
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {users.map(user => (
            <Table.Row
              key={user.id}
              className="individual-wallet-table__row"
            >
              <Table.Cell className="individual-wallet-table__cell--name">
                <Link
                  to={`/wallets/individual/${user.id}`}
                  className="individual-wallet-table__name-link"
                >
                  <Thumbnail
                    name={`${user.first_name} ${user.last_name}`}
                  />
                  <span className="individual-wallet-table__name-text">
                    {`${user.first_name} ${user.last_name}`}
                  </span>
                </Link>
              </Table.Cell>
              <Table.Cell className="individual-wallet-table__cell--number">
                {formatNumber(user.wallet_balance || 0)}
              </Table.Cell>
              <Table.Cell className="individual-wallet-table__cell--number">
                {formatNumber(user.savings_balance || 0)}
              </Table.Cell>
              <Table.Cell className="individual-wallet-table__cell--number">
                {formatNumber(user.social_funds_balance || 0)}
              </Table.Cell>
              <Table.Cell className="individual-wallet-table__cell--status">
                <span
                  className={`individual-wallet-table__status individual-wallet-table__status--${user.status}`}
                >
                  {user.status?.toUpperCase()}
                </span>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </div>
  );
};

IndividualWalletTable.propTypes = {
  users: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
};

IndividualWalletTable.defaultProps = {
  error: null,
};

export default IndividualWalletTable;
